<template>
  <div>
    <div v-if="procurement_order || procurement_order != null" class="md-layout noprint">
          <md-toolbar class="md-dense color" style="width:100%">
          <div style="width:50%">
            <h3 class="md-title" style="flex:1;">
              <p
                v-if="procurement_order.procurement_order_status == 0"
                style="text-align: left; font-weight:bold;"
              >
                REGISTERED
              </p>
              <p
                v-if="procurement_order.procurement_order_status == 1"
                style="text-align: left; font-weight:bold;"
              >
                WAITING MANAGER APPROVAL
              </p>
              <p
                v-if="procurement_order.procurement_order_status == 2"
                style="text-align: left; font-weight:bold;"
              >
                REJECTED
              </p>
              <p
                v-if="procurement_order.procurement_order_status == 3"
                style="text-align: left; font-weight:bold;"
              >
                WAITING PRICE CHECK
              </p>
              <p
                v-if="procurement_order.procurement_order_status == 4"
                style="text-align: left; font-weight:bold;"
              >
                WAITING CEO APPROVAL
              </p>
              <p
                v-if="procurement_order.procurement_order_status == 5"
                style="text-align: left; font-weight:bold;"
              >
                WAITING PAYMENT
              </p>
              <p
                v-if="procurement_order.procurement_order_status == 6"
                style="text-align: left; font-weight:bold;"
              >
                PAYMENT DONE
              </p>
              <p
                v-if="procurement_order.procurement_order_status == 7"
                style="text-align: left; font-weight:bold;"
              >
                ITEM RECEIVED
              </p>
              <p
                v-if="procurement_order.procurement_order_status == 8"
                style="text-align: left; font-weight:bold;"
              >
                CANCELED
              </p>
              <p
                v-if="procurement_order.procurement_order_status == 9"
                style="text-align: left; font-weight:bold;"
              >
                ON HOLD <span v-if="procurement_order.procurement_order_status_remark" >{{ procurement_order.procurement_order_status_remark }}</span>
              </p>
            </h3>
            </div>
             <div style="width:50%; ">
              <div class="md-toolbar-section-end">
                <md-dialog :md-active.sync="active" v-bind:md-fullscreen="false">
              <md-dialog-title>
                History Status
                <md-button style="float:right;" class="md-dense md-round md-icon-button" @click="active = false">
                  <md-icon>close</md-icon>
                </md-button>

              </md-dialog-title>
              <md-card class="md-content1 md-scrollbar">
                <md-card-content>
                  <md-table>
                    <md-table-row>
                      <md-table-head><b>Change</b></md-table-head>
                      <md-table-head><b>By</b></md-table-head>
                      <md-table-head><b>Action</b></md-table-head>
                      <md-table-head><b>Status</b></md-table-head>
                    </md-table-row>
                    <md-table-row
                      v-for="(item, index) in procurement_order.po_history_status"
                      :key="index"
                    >
                      <md-table-cell>{{ $moment(item.updated_at).utc().format('DD-MM-YYYY HH:mm') }}</md-table-cell>
                      <md-table-cell>{{ item.name_by }}</md-table-cell>
                      <md-table-cell>
                        <span v-if="item.status_action == 1">Request Price Check</span>
                        <span v-if="item.status_action == 2">Approve</span>
                        <span v-if="item.status_action == 3">Reject</span>
                        <span v-if="item.status_action == 4">Approve Price</span>
                        <span v-if="item.status_action == 5">Reject Price</span>
                        <span v-if="item.status_action==6">Approve</span>
                        <span v-if="item.status_action==7">Reject</span>
                        <span v-if="item.status_action==8">Payment Done</span>
                        <span v-if="item.status_action==9">Item Receive</span>
                        <span v-if="item.status_action==10">Cancel</span>
                        <span v-if="item.status_action==11">On Hold</span>
                      </md-table-cell>
                      <md-table-cell>
                        <span v-if="item.status == 0">Registered</span>
                        <span v-if="item.status == 1">Waiting Manager Approval</span>
                        <span v-if="item.status == 2">Rejected</span>
                        <span v-if="item.status == 3">Waiting Price Check</span>
                        <span v-if="item.status == 4">Waiting CEO Approval</span>
                        <span v-if="item.status == 5">Waiting Payment</span>
                        <span v-if="item.status == 6">Payment Done</span>
                        <span v-if="item.status == 7">Item Received</span>
                        <span v-if="item.status == 8">Canceled</span>
                        <span v-if="item.status == 9">Hold <span v-if="item.status_remark">{{ item.status_remark }}</span> </span>
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>
              </md-card>
            </md-dialog>

            <md-button class="nonprint; color md-dense" @click="active = true"
              >History Status</md-button
            >
            <md-menu md-direction="bottom-start">
              <md-button
                v-if="
                procurement_order.procurement_order_status != 2 &&
                procurement_order.procurement_order_status != 7"
                class="nonprint; md-dense color"
                md-menu-trigger
              >Change Status</md-button>
              <md-menu-content>
                <md-menu-item
                  v-if="
                  procurement_order.procurement_order_status == 0 && role.requester"
                  class="noprint"
                  @click="updateStatusConfirmation(1, 'Request Price Check')"
                >Request Price Check</md-menu-item> 
                <md-menu-item
                  v-if="
                  procurement_order.procurement_order_status == 1 && role.approver"
                  class="noprint"
                  @click="updateStatusConfirmation(4, 'Approve')"
                >Approve</md-menu-item>
                <md-menu-item
                  v-if="
                  procurement_order.procurement_order_status == 1 && role.approver"
                  class="noprint"
                  @click="updateStatusConfirmation(2, 'Reject')"
                >reject</md-menu-item>
                <!-- <md-menu-item
                  v-if="
                  procurement_order.procurement_order_status == 3 && role.approver"
                  class="noprint"
                  @click="updateStatusConfirmation('Approve')"
                >Approve Price</md-menu-item> -->
                <!-- <md-menu-item
                  v-if="
                  procurement_order.procurement_order_status == 3 && role.approver"
                  class="noprint"
                  @click="updateStatusConfirmation('Reject', true)"
                >Reject Price</md-menu-item> -->
                
                <md-menu-item
                  v-if="
                  procurement_order.procurement_order_status == 4 && 
                   (check_object_value(division,'name',['Admin']) || check_object_value(division,'name',['CEO']))"
                  class="noprint"
                  @click="updateStatusConfirmation(5, 'Approve')"
                >Approve</md-menu-item>
                <md-menu-item
                  v-if="
                  procurement_order.procurement_order_status == 4 &&
                  (check_object_value(division,'name',['Admin']) || check_object_value(division,'name',['CEO']))"
                  class="noprint"
                  @click="updateStatusConfirmation(2, 'Reject')"
                >Reject</md-menu-item>
                <md-menu-item
                  v-if="
                  procurement_order.procurement_order_status == 5 && role.requester"
                  class="noprint"
                  @click="updateStatusConfirmation(9, 'Hold', true)"
                >Hold</md-menu-item>
                <md-menu-item
                  v-if="
                  procurement_order.procurement_order_status == 9 &&
                  (check_object_value(division,'name',['Admin']) || check_object_value(division,'division_id',[8]))"
                  class="noprint"
                  @click="updateStatusConfirmation(6, 'Payment Done')"
                >Payment Done</md-menu-item>
                <md-menu-item
                  v-if="
                  procurement_order.procurement_order_status == 5 &&
                  (check_object_value(division,'name',['Admin']) || check_object_value(division,'division_id',[8]))"
                  class="noprint"
                  @click="updateStatusConfirmation(6, 'Payment Done')"
                >Payment Done</md-menu-item>
                <md-menu-item
                  v-if="
                  procurement_order.procurement_order_status == 6 &&
                   (check_object_value(division,'name',['Admin']) || check_object_value(division,'name',['Auto Manager']))"
                  class="noprint"
                  @click="updateStatusConfirmation(7, 'Item Received')"
                >Item Received</md-menu-item>
                <md-menu-item
                  v-if="
                  (procurement_order.procurement_order_status == 4 || procurement_order.procurement_order_status == 5) && 
                  role.approver"
                  class="noprint"
                  @click="updateStatusConfirmation(8, 'Cancel')"
                >Cancel</md-menu-item>
                <!-- <md-menu-item v-if="procurement_order.procurement_order_status==2 && role.requester" class="noprint" @click="updateStatusConfirmation('Item Received')">Request Price Check</md-menu-item> -->
              </md-menu-content>
            </md-menu>
            <md-button  class="noprint md-dense color md-icon-button" @click="printPage()" ><md-icon>print</md-icon></md-button>
            <!-- <md-menu md-direction="bottom-start" style="margin-right:20px;">
              <md-button class="nonprint; md-dense md-icon-button md-info" md-menu-trigger><md-icon>more_vert</md-icon></md-button>
              <md-menu-content>
                <md-menu-item
                  v-if="
                  (procurement_order.procurement_order_status == 0 && role.update) ||
                  (procurement_order.procurement_order_status == 6 && role.update)"
                  @click="editProcurementOrder(procurement_order.id)"
                >Edit</md-menu-item>
                <md-menu-item
                  v-if="
                  procurement_order.procurement_order_status == 0 && role.delete "
                  @click="deleteConfirmation(procurement_order.id)">Delete</md-menu-item>
                <md-menu-item @click="backtoList">Back to PO list</md-menu-item>
              </md-menu-content>
            </md-menu> -->
          <md-button class="md-icon-button md-dense color" @click="closeDetail()"><md-icon>close</md-icon></md-button>
          </div>
          </div>
          </md-toolbar>
          <!-- <div class="md-layout-item md-size-100 md-small-size-100">
                <md-table>
                  <md-table-row>
                    <md-table-head style="text-align:center"><b>Dealer No</b></md-table-head>
                    <md-table-head style="text-align:center"><b>Dealer Name</b></md-table-head>
                    <md-table-head style="text-align:center"><b>Use PPN</b></md-table-head>
                  </md-table-row>
                  <md-table-row>
                    <md-table-cell style="text-align:center">{{ procurement_order.procurement_order_dealer.dealer_no }}</md-table-cell>
                    <md-table-cell style="text-align:center">{{ procurement_order.procurement_order_dealer.dealer_name }}</md-table-cell>
                    <md-table-cell style="text-align:center">{{ procurement_order.procurement_order_dealer.dealer_use_ppn }}</md-table-cell>
                  </md-table-row>
                </md-table>
          </div> -->

          <div class="md-layout-item md-medium-size-200 md-xsmall-size-200 md-size-100">
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-primary">
                <div class="card-text">
                  <h4 class="title">Item Info</h4>
                </div>
              </md-card-header>
              <md-card-content>
                <table style="width:70mm;">
                  <colgroup>
                <col style="width: 24mm">
                <col style="width: 3mm">
                <col style="width: 43mm">
              </colgroup>
                  <tr>
                    <td style=" font-size: 15px;"><b>Dealer No</b></td>
                    <td style="font-size: 15px;"> :</td>
                    <td style="font-size: 15px;">{{ procurement_order.procurement_order_dealer.dealer_no }}</td>
                  </tr>
                  <tr>
                    <td style=" font-size: 15px;"><b>Dealer Name</b></td>
                    <td style="font-size: 15px;">:</td>
                    <td style="font-size: 15px;">{{ procurement_order.procurement_order_dealer.dealer_name }}</td>
                  </tr>
                  <tr>
                    <td style=" font-size: 15px;"><b>Use PPN</b></td>
                    <td style="font-size: 15px;">:</td>
                    <td style="font-size: 15px;">{{ procurement_order.procurement_order_dealer.dealer_use_ppn }}</td>
                  </tr>
                </table>
                <br>
                <md-divider></md-divider>
                <md-table>
                  <md-table-row>
                    <md-table-head ><b>No.</b></md-table-head>
                    <md-table-head ><b>Item Code</b></md-table-head>
                    <md-table-head ><b>Item Name</b></md-table-head>
                    <md-table-head style="text-align:center;"><b>Item Price</b></md-table-head>
                    <md-table-head style="text-align:center;"><b> Disc(%)</b></md-table-head>
                    <md-table-head style="text-align:center;"><b>Qty</b></md-table-head>
                    <md-table-head ><b>MOQ</b></md-table-head>
                    <md-table-head ><b>Alert Price</b></md-table-head>
                    <md-table-head ><b>Subtotal</b></md-table-head>
                  </md-table-row>
                  <md-table-row v-if="procurement_order.procurement_order_item.length==0">
                    <md-table-cell colspan="9" class="nodata">No Data Available</md-table-cell>
                  </md-table-row>
                  <md-table-row v-else v-for="(item, index) in procurement_order.procurement_order_item" :key="index">
                    <md-table-cell>{{ index + 1 }}</md-table-cell>
                    <md-table-cell>
                      <span v-if="item.spare_part" >{{ item.spare_part.spare_part_master_code }}</span>
                    </md-table-cell>
                    <md-table-cell>  
                      <span v-if="item.spare_part">{{ item.spare_part.spare_part_master_name }}</span>
                      </md-table-cell>
                    <md-table-cell><span style="float: left;">Rp</span><span style="float: right;">{{ formatPrice(item.item_procurement_price) }}</span></md-table-cell>
                    <md-table-cell style="text-align:center;"><span >{{ formatPrice(item.item_procurement_discount) }}%</span></md-table-cell>
                    <md-table-cell ><span style="text-align:center;">{{ parseFloat(item.item_procurement_order_qty) }}</span></md-table-cell>
                    <md-table-cell v-if="item.spare_part_price">{{ item.spare_part_price.spare_part_price_minimum_order_quantity }}</md-table-cell>
                    <md-table-cell v-else></md-table-cell>
                    <md-table-cell><span v-if="item.spare_part" style="float: left;">Rp</span><span style="float: right;">{{ formatPrice(item.spare_part.spare_part_master_alert_price) }}</span></md-table-cell>
                    <md-table-cell><span style="float: left;">Rp</span><span style="float: right;">{{ formatPrice( item.item_procurement_price * item.item_procurement_order_qty) }}</span></md-table-cell>
                  </md-table-row>
                  <md-table-row class="TotalsFooter" colspan="7">
                    <md-table-cell colspan="7" ></md-table-cell>
                    <md-table-cell style="font-weight:bold;">Total w/o Tax</md-table-cell>
                    <md-table-cell>
                      <span style="float: left;">Rp</span><span style="float: right;">{{ formatPrice(total) }}</span>
                    </md-table-cell>
                  </md-table-row>
                  <md-table-row class="TotalsFooter" colspan="7">
                    <md-table-cell colspan="7" ></md-table-cell>
                    <md-table-cell style="font-weight:bold;">Tax</md-table-cell>
                    <md-table-cell><span style="float: left;">Rp</span><span v-if="(procurement_order.procurement_order_dealer.dealer_use_ppn == 'Yes')"
                      style="float: right;">{{ formatPrice((total * 11) / 100) }}</span>
                      <span v-else style="float: right;">{{ 0 }}</span>
                    </md-table-cell>
                  </md-table-row>
                  <md-table-row class="TotalsFooter" colspan="7">
                    <md-table-cell colspan="7" ></md-table-cell>
                    <md-table-cell style="font-weight:bold;">Total</md-table-cell>
                    <md-table-cell>
                      <span style="float: left;">Rp</span>
                      <span style="float: right;" v-if="(procurement_order.procurement_order_dealer.dealer_use_ppn == 'Yes')">{{ formatPrice(total + (total * 11) / 100) }}</span>
                      <span style="float: right;" v-else>{{ formatPrice(total) }}</span>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </md-card-content>
            </md-card>
          </div>

              <div class="md-layout-item">
                <md-card>
                  <md-card-header class="md-card-header-text md-card-header-primary">
                    <div class="card-text">
                      <h4 class="title">Remark</h4>
                    </div>
                  </md-card-header>
                  <md-card-content style="height:130px">
                    <p style="margin-top:20px;" v-if="procurement_order.procurement_order_remark" >
                      {{ procurement_order.procurement_order_remark }}
                    </p>
                    <p v-else class="nodata" style="padding-top:37px; padding-bottom:37px; text-align:center;">NO REMARK</p>
                  </md-card-content>
                </md-card>
              </div>
              <div class="md-layout-item">
                <md-card>
                  <md-card-header class="md-card-header-text md-card-header-primary">
                    <div class="card-text">
                      <h4 class="title">Attachment</h4>
                    </div>
                  </md-card-header>
                  <md-card-content>
                    <md-table>
                      <md-table-row>
                        <md-table-head><b>Quotation</b></md-table-head>
                        <!-- <md-table-head><b>PO</b></md-table-head> -->
                        <md-table-head><b>Invoice</b></md-table-head>
                        <md-table-head><b>Payment</b></md-table-head>
                      </md-table-row>
                      <md-table-row>
                        <md-table-cell>
                          <a v-if="procurement_order.procurement_order_attach_quotation_url" :href="procurement_order.procurement_order_attach_quotation_url" target="_blank">
                            attach_quotation
                          </a>
                          <a v-else style="color:#aaaa; text-align: center;">No file</a>
                        </md-table-cell>
                        <!-- <md-table-cell>
                          <a v-if="procurement_order.procurement_order_attach_po_url" :href="procurement_order.procurement_order_attach_po_url" target="_blank">
                            Attach po
                          </a>
                          <a v-else style="color:#aaaa; text-align: center;">No file</a>
                        </md-table-cell> -->
                        <md-table-cell>
                          <span>
                            <a v-if="procurement_order.procurement_order_attach_invoice_url" :href="procurement_order.procurement_order_attach_invoice_url" target="_blank">
                            Attach invoice
                          </a>
                            <a v-else style="color:#aaaa; text-align: center;">No file</a>
                            <!-- <md-button class="md-icon-button md-dense color" @click="modalOpenUploadInvoice()">{{procurement_order.procurement_order_attach_invoice_url? 'Change':'Add'}}</md-button> -->
                            <a v-if="(role.create || role.update) && (procurement_order.procurement_order_status == 5 || procurement_order.procurement_order_status == 6 || procurement_order.procurement_order_status == 7)" @click="modalOpenUploadInvoice"> | {{procurement_order.procurement_order_attach_invoice_url? 'Change':'Add'}}</a>
                          </span>
                        </md-table-cell>
                        <md-table-cell>
                          <span>
                            
                            <a v-if="procurement_order.procurement_order_attach_payment_url" :href="procurement_order.procurement_order_attach_payment_url" target="_blank">
                              Attach payment
                            </a>
                            <a v-else style="color:#aaaa; text-align: center;">No file</a>
                            <!-- <md-button class="md-icon-button md-dense color" @click="uploadPaymentProof()">{{procurement_order.procurement_order_attach_payment_url? 'Change':'Add'}}</md-button> -->
                            <a v-if="(procurement_order.procurement_order_status == 5 || procurement_order.procurement_order_status == 6 || procurement_order.procurement_order_status == 7) && (check_object_value(division,'name',['Admin']) || check_object_value(division,'division_id',[8]))" @click="modalOpenUploadPaymentProof"> | {{procurement_order.procurement_order_attach_payment_url? 'Change':'Add'}}</a>
                          </span>
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </md-card-content>
                </md-card>
              </div>
    </div>

    <div
      v-if="procurement_order || procurement_order != null"
      class="md-layout print"
    >
      <div class="md-layout-item md-size-100">
        <md-card  style=" box-shadow: none;">
          <md-card-content>
            
           
            <table style="width:100%; line-height: 1.6; table-layout: fixed;">
              <colgroup>
                <col style="width: 90mm">
                <col style="width: 90mm">
              </colgroup>
              <tr>
                <td ><h3 style="font-weight:bold; font-size: 30px;">Purchase Order</h3></td>
                <td  rowspan="2">
                  <img
                    src="@/pages/Dashboard/Workshop/ProcurementOrder/Component/logocharged.png"
                    style="float:right; width:50%; margin-right:50px; border: 0px solid;  max-width:250px;"
                  />
                </td>
              </tr>
              <tr >
                <td >
                  <span style="font-weight:bold; font-size: 15px;">PT. INDO AUTO SERVIS</span>
                  <br/>
                  <span >Ruko Bukit Gading Mediterania (Florencia) Blok A No. 01,
                    <br/>Kel. Kelapa Gading Barat, Kec. Kelapa Gading,
                    <br/>DKI Jakarta, Indonesia</span>
                </td>
              </tr>
            </table>

            <table style="width:100%; margin-top:10px; line-height: 1.6; table-layout: fixed;">
              <tr>
                <td style="width:120mm; vertical-align:top;">
                  <table style=" table-layout: fixed;">
                    <!-- <colgroup>
                      <col style="width: 90mm">
                      <col style="width: 90mm">
                    </colgroup> -->
                    <tr>
                      <td style="font-weight:bold;">ORDER TO</td>
                    </tr>
                    <tr>
                      <td>{{ procurement_order.procurement_order_dealer.dealer_name }}</td>
                      </tr>
                      <tr>
                      <td>{{ procurement_order.procurement_order_dealer.dealer_address }}</td>
                    </tr>
                  </table>
                </td>
                <td>
                  <table style=" table-layout: fixed;">
                    <!-- <colgroup>
                      <col style="width: 90mm">
                      <col style="width: 90mm">
                    </colgroup> -->
                    <tr>
                      <td>Reference</td>
                      <td>{{ procurement_order.procurement_order_no }}</td>
                    </tr>
                    <tr>
                      <td>Date</td>
                      <td>{{ procurement_order.created_at }}</td>
                    </tr>
                    <tr>
                      <td>Status</td>
                      <td></td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>

            <table
              
              style="border-collapse:collapse; width:100%; line-height: 1.6;  margin-top:10px; margin-bottom:10px;"
            >
              <thead>
                <tr style=" border-bottom: 1pt solid red; border-top: 1pt solid red;">
                  <th class="title-name" style="width:10mm">No</th>
                  <th class="title-name" style="width:300px">Item Name</th>
                  <!-- <th class="title-name">Item Code</th> -->
                  <th class="title-name">Price</th>
                  <th class="title-name">Disc(%)</th>
                  <th class="title-name">Qty</th>
                  <!-- <th class="title-name">MOQ</th> -->
                  <!-- <th class="title-name">Alert Price</th> -->
                  <th class="title-name">SubTotal</th>
                </tr>
              </thead>
              <tr
                v-for="(item,
                index) in procurement_order.procurement_order_item"
                :key="index"
                
              >
                <td style="text-align:center;">{{ index + 1 }}</td>
                <td style="width:300px; text-align:center;">{{ item.spare_part.spare_part_master_name }}({{ item.spare_part.spare_part_master_code }})</td>
                <!-- <td>{{ item.spare_part.spare_part_master_code }}</td> -->
                <td>
                  <span style="float: left;">Rp</span
                  ><span style="float: right;">{{
                    formatPrice(item.item_procurement_price)
                  }}</span>
                </td>
                <td style="text-align:center;">{{ formatPrice(item.item_procurement_discount) }}%</td>
                <td style="text-align:center;">{{ parseFloat(item.item_procurement_order_qty) }}</td>
                <!-- <td v-if=" item.spare_part_price" style="text-align:center;">{{ item.spare_part_price.spare_part_price_minimum_order_quantity }}</td>
                <td v-else style="text-align:center;"></td> -->
                <!-- <td>
                  <span style="float: left; margin-left:2px">Rp</span
                  ><span v-if="item.spare_part" style="float: right;">{{
                    formatPrice(item.spare_part.spare_part_master_alert_price)
                  }}</span>
                </td> -->
                <td>
                  <span style="float: left; margin-left:10px">Rp</span
                  ><span style="float: right;">{{
                    formatPrice(
                      item.item_procurement_price *
                        item.item_procurement_order_qty
                    )
                  }}</span>
                </td>
              </tr>
            </table>
            
            <table style="border-collapse:collapse; width:100%; line-height:1.6; border-top: 1pt solid red;  margin-bottom:10px;">
              <colgroup>
                <col style="width: 120mm" />
                <col style="width: 60mm" />
              </colgroup>
              
              <tr>
                <td>
                  <table style="border-collapse:collapse; line-height:1.6;">
                    <tr>
                      <td style="font-weight:bold;">Terms of Payment</td>
                    </tr>
                    <tr>
                      <td >- Full Payment after P.O Release</td>
                    </tr>
                  </table>
                </td>
                <td >
                  <table style="border-collapse:collapse; font-size: 11px; line-height:1.6;">
                    <colgroup>
                      <col style="width: 30mm" />
                      <col style="width: 30mm" />
                    </colgroup>
                    <tr >
                      <td style="text-align:right">
                        <b>Total w/o Tax</b>
                      </td>
                      <td>
                        <span style="float: left; margin-left:16px;">Rp</span
                        ><span style="float: right; margin-right:10px;">{{ formatPrice(total) }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align:right"><b>Tax</b></td>
                      <td>
                        <span style="float: left; margin-left:16px;">Rp</span
                        ><span
                          v-if="
                            (procurement_order.procurement_order_dealer.dealer_use_ppn ==
                              'Yes')
                          "
                          style="float: right; margin-right:10px;"
                          >{{ formatPrice((total * 11) / 100) }}</span
                        >
                        <span v-else style="float: right; margin-right:10px;">{{ 0 }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align:right"><b>Total</b></td>
                      <td>
                        <span style="float: left; margin-left:16px;">Rp</span
                        ><span style="float: right; margin-right:10px;" v-if="
                            (procurement_order.procurement_order_dealer.dealer_use_ppn ==
                              'Yes')
                          ">{{
                          formatPrice(total + (total * 11) / 100)
                        }}</span>
                        <span v-else style="float: right; margin-right:10px;">{{formatPrice(total)}}</span>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              
            </table>

            <table>
              <tr>
                <td  rowspan="">
                  <img
                    src="@/pages/Dashboard/Workshop/ProcurementOrder/Component/ttd.png"
                    style="float:right; width:100%;  max-width:250px;"
                  />
                </td>
              </tr>
            </table>

            <table
              class="noprint"
              style="width:100%; border-collapse: collapse; margin-top: 5px; "
            >
              <colgroup>
                <col style="width: 25%" />
                <col style="width: 25%" />
                <col style="width: 25%" />
                <col style="width: 25%" />
              </colgroup>
              <tr>
                <td
                  colspan="4"
                  class="title-name"
                  style="border:1px solid black; font-weight:bold; text-align:center;"
                >
                  Attachments
                </td>
              </tr>
              <tr>
                <td
                  class="title-name"
                  style="border:1px solid black; font-weight:bold; text-align:center;"
                >
                  Quotation
                </td>
                <!-- <td
                  class="title-name"
                  style="border:1px solid black; font-weight:bold; text-align:center;"
                >
                  PO
                </td> -->
                <td
                  class="title-name"
                  style="border:1px solid black; font-weight:bold; text-align:center;"
                >
                  Invoice
                </td>
                <td
                  class="title-name"
                  style="border:1px solid black; font-weight:bold; text-align:center;"
                >
                  Payment
                </td>
              </tr>
              <tr>
                <td
                  style="border:1px solid black; font-weight:bold; text-align:center;"
                >
                  <!-- <a
                    :href="
                      url_storage +
                        'po_attachment/' +
                        procurement_order.procurement_order_attach_folder +
                        '/' +
                        procurement_order.procurement_order_attach_quotation
                    "
                    target="_blank"
                  >
                    {{ procurement_order.procurement_order_attach_quotation }}
                  </a> -->
                  <a v-if="procurement_order.procurement_order_attach_quotation_url" :href="procurement_order.procurement_order_attach_quotation_url" target="_blank">
                    attach_quotation
                    </a>
                </td>
                <!-- <td
                  style="border:1px solid black; font-weight:bold; text-align:center;"
                >
                 
                  <a v-if="procurement_order.procurement_order_attach_po_url" :href="procurement_order.procurement_order_attach_po_url" target="_blank">
                    attach_po
                    </a>
                </td> -->
                <td
                  style="border:1px solid black; font-weight:bold; text-align:center;"
                >
                  <!-- <a
                    :href="
                      url_storage +
                        'po_attachment/' +
                        procurement_order.procurement_order_attach_folder +
                        '/' +
                        procurement_order.procurement_order_attach_invoice
                    "
                    target="_blank"
                  >
                    {{ procurement_order.procurement_order_attach_invoice }}
                  </a> -->
                  <a v-if="procurement_order.procurement_order_attach_invoice_url" :href="procurement_order.procurement_order_attach_invoice_url" target="_blank">
                    attach_invoice
                    </a>
                </td>
                <td
                  style="border:1px solid black; font-weight:bold; text-align:center;"
                >
                  <!-- <a
                    :href="
                      url_storage +
                        'po_attachment/' +
                        procurement_order.procurement_order_attach_folder +
                        '/' +
                        procurement_order.procurement_order_attach_payment
                    "
                    target="_blank"
                  >
                    {{ procurement_order.procurement_order_attach_payment }}
                  </a> -->
                  <a v-if="procurement_order.procurement_order_attach_payment_url" :href="procurement_order.procurement_order_attach_payment_url" target="_blank">
                    attach_payment
                    </a>
                </td>
              </tr>
            </table>

            <!-- <table class="table-inside-td" style="width:100%; border-collapse: collapse; table-layout: fixed;" >
          <colgroup>
                    <col style="width: 180mm">
            </colgroup>
            <tr style="border-right:1px solid black; border-left:1px solid black; border-bottom:1px solid black;">
              <td >{{procurement_order.procurement_order_remark}}</td>
              
            </tr>
          </table> -->
          </md-card-content>
          <!-- <button class="noprint" @click="printInvoice" >Print Invoice</button>
          <button class="noprint" @click="generateReport" >Print Invoice</button> -->
        </md-card>
      </div>
    </div>

    <div v-bind:style="{ display: not_found}">
      <center v-if="procurement_order == null">
        <h1>Not Found!</h1>
        <p>
          <a href="" @click="backToList()">Go to List?</a>
        </p>
      </center>
    </div>
    <modal ref="modalUploadPaymentProofPage" class="coba">
    <template v-slot:body >
      <upload-payment-proof :data_id="$refs.modalUploadPaymentProofPage.data" />
    </template>
  </modal>
  <modal ref="modalUploadInvoicePage" class="coba">
    <template v-slot:body >
      <upload-invoice :data_id="$refs.modalUploadInvoicePage.data" />
    </template>
  </modal>
  </div>
</template>

<script>
  import {ValidationError} from "@/components";
  import formMixin from "@/mixins/form-mixin";
  import angkaTerbilang from '@develoka/angka-terbilang-js';
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2';
  import Swal from 'sweetalert2';
  import UploadPaymentProof from "@/pages/Dashboard/Workshop/ProcurementOrder/Modal/uploadPaymentProof.vue";
  import UploadInvoice from "@/pages/Dashboard/Workshop/ProcurementOrder/Modal/uploadInvoice.vue";
  import { Modal } from "@/components";
  
  Vue.use(VueSweetalert2);


  const url_storage = process.env.VUE_APP_STORAGE_BASE_URL;
  export default {
     name: "detail-nota-part",

    // props: {
    //   procurement_order: Object,
    // },

    components: {
      Modal,
      "upload-payment-proof": UploadPaymentProof,
    "upload-invoice": UploadInvoice
      
    }, 

    props: {
    data_id: null,
    },

    mixins: [formMixin],

    data: () => ({
      active: false,
      not_found: 'none',
      role:'',
      url_storage : url_storage,
      procurement_order: null,
      total:0,
      division: null,
    }),

    created() {
      this.getProcurementOrderData();
    },

    methods: {
      //fungsi format mata uang
      formatPrice(value) {
        let val = (value/1).toFixed().replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      }, 
      
      //fungsi ambil data ketika page baru dibuka
      async getProcurementOrderData(){
        //ambil list role permission user
        this.role =  await this.$store.getters["role_permission/route_filter"]
        var me = await this.$store.getters["profile/me"]
        // this.role.role = me.role_name.name_string.split(",") 
        this.division = me.role_name
        // console.log(this.division) 
        //ambil data dari server berdasarkan id po yang dikirim di route
        await this.$store.dispatch("workshop_procurement_order/get", this.data_id.id)
        this.procurement_order = await this.$store.getters["workshop_procurement_order/procurement_order"]

         //check apakah data dari api ada
        if(!this.procurement_order){
          //jika tidak ada munculkan bagian not found yang defaultnya di hide
          this.not_found = "block"
          return
        }
        this.calculateTotal();
        
        
        // this.procurement_order.faktur_total_terbilang =  angkaTerbilang(this.procurement_order.faktur_total_biaya_jasa + this.procurement_order.faktur_total_biaya_spare_part + this.procurement_order.faktur_materai + this.procurement_order.faktur_ppn)
        console.log(await this.$store.getters["workshop_procurement_order/procurement_order"])
       
        
      },

      //fungsi untuk pindah ke page edit sekaligus mengirim informasi dari id po
      editProcurementOrder(id) {
      this.$router.push({ name: 'Edit Procurement Order', params: { procurement_order:id, id } })
      },
      //fungsi untuk kembali ke list
      backtoList() {
      this.$router.replace({ name: 'List Procurement Order'})
      },

//fungsi untuk memunculkan alert konfirmasi ketika menekan tombol hapus
    deleteConfirmation(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You wont be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.deleteProcurementOrder(id);
        }
      });
    },

    //fungsi untuk mengirim data yang akan di hapus keserver 
    async deleteProcurementOrder(id) {
       try {
         //kirim informasi ke server
          await this.$store.dispatch("workshop_procurement_order/destroy", id)
          //panggil alert succees
          await this.$store.dispatch("alerts/success", "Procurement Order delete successfully.")
          //kembali ke list
          await this.$router.replace({name: 'List Procurement Order'});
        } catch (e) {
          //panggil alert error
          await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
          this.setApiValidation(e.response.data.errors)
        }
    },

   //fungsi untuk memunculkan alert konfirmasi ketika menekan tombol update
    updateStatusConfirmation(status, status_text) {
      if(status == 9){
        Swal.fire({

          title: 'Are you sure want to change the status to '+status_text+'?',
          html:
              '<fieldset><legend>Hold Reason:</legend>'+
              '<div><input style="margin: .4rem;" type="text" id="remark" name="remark" value="">' +
              '<div class="swal2-validation-message" id="swal2-validation-message-hold-reason" style="display: none;">You need write the reason!</div>'+
                '</fieldset>',
              
            focusConfirm: false,
            allowOutsideClick: false,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, change it!',
            cancelButtonText: 'No, cancel!',
            buttonsStyling: true,
            preConfirm: () => {
                if(document.getElementById('remark').value == ""){
                  document.getElementById("swal2-validation-message-hold-reason").style.display = "flex"; 
                }
                else{
                  document.getElementById("swal2-validation-message-hold-reason").style.display = "none"; 
                }

              return {remark:document.getElementById('remark').value !=""? document.getElementById('remark').value : null
              }
            }
            
          }).then((result) => {
            console.log(result.value.remark);
          if (result.value){
            this.updateStatus(status,result.value.remark)
          }
        });
      }
      else{
        Swal.fire({
          title: "Are you sure want to change the status to " + status_text + "?",
          text: "The data will Saved!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, change it!",
          cancelButtonText: "No, cancel!",
          buttonsStyling: true,
        }).then((result) => {
          if (result.value) {
            this.updateStatus(status);
          }
        });
      }
    },
    //fungsi update status
   async updateStatus(status,remark=null) {
    var data = null
      if(remark!=null){
         data = {
          type: "workshop_procurement_orders",
          id: this.procurement_order.id,
          status: status,
          remark: remark,
        };
      }
      else{
         data = {
          type: "workshop_procurement_orders",
          id: this.procurement_order.id,
          status: status
        };
      }
      

      //console.log(data)
      try {
        //kirim data keserver
        await this.$store.dispatch("workshop_procurement_order/update", data);
        //panggil alert succes
        await this.$store.dispatch(
          "alerts/success",
          "Status Successfully update."
        );
        //jalankan fungsi kembali kelist
        this.getProcurementOrderData();
      } catch (e) {
        //panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong"
        );
      }
    },
    // async updateStatus(rejected_status) {
    //   console.log("sdad");
    //   var rejected = false;
    //   if (rejected_status == true) {
    //     rejected = true;
    //   }
    //   const data = {
    //     type: "workshop_procurement_orders",
    //     id: this.procurement_order.id,
    //     current_status: this.procurement_order.procurement_order_status,
    //     rejected: rejected,
    //   };

    //     console.log(data)
    //     try {
    //       //kirim informasi ke server
    //     await this.$store.dispatch("workshop_procurement_order/update_status", data);
    //     //panggil alert success
    //     await this.$store.dispatch(
    //       "alerts/success",
    //       "Status Successfully update."
    //     );
    //     // await this.$router.push({name: 'List Service Estimate'}{name: 'Detail Service Estimate', params: { id: procurement_order.id }});
    //     // await this.$router.push({ name: "List Procurement Order" });
    //     this.getProcurementOrderData();
    //   } catch (e) {
    //     //panggil alert error
    //     await this.$store.dispatch(
    //       "alerts/error",
    //       "Oops, something went wrong"
    //     );closeDetail
    //   }
    // },
 
    async closeDetail(){
      if(this.data_id.modal_ref){
        this.data_id.modal_ref.closeModal()
      }
      else{
       this.$parent.$parent.modalCloseDetail();
      } 
    },

    modalOpenUploadInvoice(){
      this.$refs.modalUploadInvoicePage.openModal({id:this.data_id.id});
    },

    modalCloseUploadInvoice(){
      this.$refs.modalUploadInvoicePage.closeModal();
      this.getProcurementOrderData();
    },

    modalOpenUploadPaymentProof(){
      this.$refs.modalUploadPaymentProofPage.openModal({id:this.data_id.id});
    },

    modalCloseUploadPaymentProof(){
      this.$refs.modalUploadPaymentProofPage.closeModal();
      this.getProcurementOrderData();
    }, 

//fungsi untuk mengitung total dri semua qty dan price
    calculateTotal(){
          
        var total = 0;
        this.procurement_order.procurement_order_item.map(function(value, key) {
            total = total + (value.item_procurement_price * value.item_procurement_order_qty)
            
           
        });
        this.total = total
          
      },

    

    //   calculateTotal(){
    //       console.log(this.procurement_order.procurement_order_part)
    //     var total = 0;
    //     this.procurement_order.procurement_order_part.map(function(value, key) {
    //         if(value.service_estimate_spare_part_discount == null){
    //             total = total + (value.spare_part_master_unit_price * value.service_estimate_spare_part_qty)
    //         } else{
    //             total = total + (value.spare_part_master_unit_price * value.service_estimate_spare_part_qty) - ((value.spare_part_master_unit_price * value.service_estimate_spare_part_qty) * value.service_estimate_spare_part_discount / 100)
    //         }

    //     });
    //     this.total = total

    //   },

      //kembali ke list
      async backToList(){
          await this.$router.replace({name: 'List Nota Part'})
      },
      //fungsi untuk print preview mode
      printPage(){
         window.print()
      },

    check_object_value(array, key, value) {
        //return array.some(object => object[key] === value);
        return array.some(object => value.includes(object[key]));
        },
      // async closePrint () {
      //   document.body.removeChild(this.__container__);
      // },

      // async setPrint () {
      //   this.contentWindow.__container__ = this;
      //   this.contentWindow.onbeforeunload = closePrint;
      //   this.contentWindow.onafterprint = closePrint;
      //   this.contentWindow.focus(); // Required for IE
      //   this.contentWindow.print();
      // },

      // async printPage (sURL) {
      //   var oHiddFrame = document.createElement("iframe");
      //   oHiddFrame.onload = setPrint;
      //   oHiddFrame.style.visibility = "hidden";
      //   oHiddFrame.style.position = "fixed";
      //   oHiddFrame.style.right = "0";
      //   oHiddFrame.style.bottom = "0";
      //   oHiddFrame.src = sURL;
      //   document.body.appendChild(oHiddFrame);
      // }
      
    }
  };
</script>
<style scoped>
.title-name {
  background-color: powderblue;
}
table {
  width: 100%;
  table-layout: fixed;
  font-size: 0.8em;
}
.table-kotak {
  border-collapse: collapse;
}
table.table-kotak td {
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
  text-align: center;
}
table.table-kotak th {
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
.print {
  visibility: hidden;
}
.checkboxes label {
  display: inline-block;
  padding-right: 10px;
  white-space: nowrap;
}
.checkboxes input {
  vertical-align: middle;
}
.checkboxes label span {
  vertical-align: middle;
}
.checkboxes td {
  padding: 0px;
  line-height: 0px;
  margin: 0px;
}
.checkboxes {
  padding: 0px;
  line-height: 0px;
  margin: 0px;
}
.info {
  line-height: 17px;
}
.info td {
  margin: 4px;
}
.bold-title {
  font-weight: bold;
}

table#font-size td {
  font-size: 11px;
}
.table-inside-td td {
  vertical-align: top;
  text-align: left;
  padding-left: 5px;
  padding-right: 5px;
}

@media print {
  .print {
    visibility: visible;
  }
  .noprint {
    display: none;
  }
}

md-table-head{
  font-weight: bold;
}

.nonborder{
  border: none !important;
  box-shadow: none;
}
/* .md-card{
  box-shadow: 0 16px 24px 2px rgb(0 0 0 / 14%), 0 6px 30px 5px rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(0 0 0 / 20%);
} */

.md-card{
  box-shadow: 0 3px 5px 1px rgb(0 0 0 / 14%);
}

.nodata{
  
  color:#aaa;
  text-align: center;
}

/* .md-layout{
  background-color: white;
} */

.color{
  background-color: #1976d2 !important;
}

</style>
